import List from './List';
import ListItem from './ListItem';
List.Item = ListItem;
export { default as ListItem } from './ListItem';
export default List;